// Server Action names
export const SAGA_LOAD_POI = 'SAGA_LOAD_POI';
export const SAGA_GET_POI_DUPLICATES = 'SAGA_GET_POI_DUPLICATES';
export const SAGA_PATCH_POI = 'SAGA_PATCH_POI';

// POI actions
export const SET_POI = 'SET_POI';
export const RESET_POI = 'RESET_POI';

// POI Duplicate actions
export const SET_POI_DUPLICATES = 'SET_POI_DUPLICATES';
export const RESET_POI_DUPLICATES = 'RESET_POI_DUPLICATES';

// Fence Drawing Action names
export const OPEN_FENCE_SAVE_CONFIRMATION_DIALOG = 'OPEN_FENCE_SAVE_CONFIRMATION_DIALOG';
export const CLOSE_FENCE_CONFIRMATION_DIALOG = 'CLOSE_FENCE_CONFIRMATION_DIALOG';

export const OPEN_POI_UPDATE_CONFIRMATION_DIALOG = 'OPEN_POI_UPDATE_CONFIRMATION_DIALOG';
export const CLOSE_POI_UPDATE_CONFIRMATION_DIALOG = 'CLOSE_POI_UPDATE_CONFIRMATION_DIALOG';

export const UPDATE_POI_CENTER = 'UPDATE_POI_CENTER';
export const RESET_FENCE = 'RESET_FENCE';
export const NEW_FENCE_DRAWN = 'NEW_FENCE_DRAWN';
export const ADD_FENCE = 'ADD_FENCE';
export const DELETE_FENCE = 'DELETE_FENCE';

// Server Action Names
export const SELECT_FENCE = 'SELECT_FENCE';
export const SAGA_CREATE_FENCE = 'SAGA_CREATE_FENCE';
export const SAGA_UPDATE_POI_CENTER = 'SAGA_UPDATE_POI_CENTER';
export const SAGA_REMOVE_DUPLICATE_POI = 'SAGA_REMOVE_DUPLICATE_POI';
export const SAGA_UPDATE_POI_FENCE = 'SAGA_UPDATE_POI_FENCE';

export const SET_ORGANIZATION_POIS = 'SET_ORGANIZATION_POIS';

// Temp action names
export const SET_NEW_FENCE_MAP_CENTER = 'SET_NEW_FENCE_MAP_CENTER';

export const serverLoadPOI = (poiId) => {
    return {
        type: SAGA_LOAD_POI,
        payload: {
            poiId,
        },
    }
}

export const serverGetPOIDuplicates = (poiId) => {
	return {
		type: SAGA_GET_POI_DUPLICATES,
		payload: {
			poiId,
		}
	}
}

export const serverCreateFence = (poiId, fence, accuracy) => {
	return {
		type: SAGA_CREATE_FENCE,
		payload: {
			poiId,
			fence,
			accuracy,
		}
	}
}

export const serverUpdatePOICenter = (poiId, geo, centerType) => {
	return {
		type: SAGA_UPDATE_POI_CENTER,
		payload: {
			poiId,
			geo,
			centerType,
		}
	}
}

export const serverRemoveDuplicatePOI = (poiId) => {
	return {
		type: SAGA_REMOVE_DUPLICATE_POI,
		payload: {
			poiId,
		}
	}
}

export const serverUpdatePOIFence = (poiId, fenceId, geo, accuracy) => {
	return {
		type: SAGA_UPDATE_POI_FENCE,
		payload: {
			poiId,
			fenceId,
			geo,
			accuracy,
		}
	}
}

export const sagaPatchPOI = (poiId, body) => {
	return {
		type: SAGA_PATCH_POI,
		payload: {
			poiId,
			body,
		}
	}
}

export const setPOI = (poi) => {
	return {
		type: SET_POI,
		payload: {
			poi,
		}
	}
}

export const resetPOI = (poiId) => {
	return {
		type: RESET_POI,
		payload: {
			poiId,
		}
	}
}

// POI DUPLICATES

export const setPOIDuplicates = (poiId, duplicates) => {
	return {
		type: SET_POI_DUPLICATES,
		payload: {
			poiId,
			duplicates,
		}
	}
}


// CREATE NEW FENCES

export const newFence = (type = '', poiId, coordinates = null, overlay = null)=>{
	return{
		type: ADD_FENCE,
		payload: {
			type,
			poiId,
			coordinates,
			overlay,
		}
	}
}

export const deleteFence = (index)=>{
	return{
		type: DELETE_FENCE,
		payload: {
			index: index
		}
	}
}

export const updatePOICenter = (poiId, geo) => {
	return {
		type: UPDATE_POI_CENTER,
		payload: {
			poiId,
			geo,
		}
	}
}

export const openFenceSaveConfirmationDialog = ()=>{
	return{
		type: OPEN_FENCE_SAVE_CONFIRMATION_DIALOG,
	}
}

export const closeFenceConfirmationDialog = ()=>{
	return{
		type: CLOSE_FENCE_CONFIRMATION_DIALOG,
	}
}

export const openPOIUpdateConfirmationDialog = ()=>{
	return{
		type: OPEN_POI_UPDATE_CONFIRMATION_DIALOG,
	}
}

export const closePOIUpdateConfirmationDialog = ()=>{
	return{
		type: CLOSE_POI_UPDATE_CONFIRMATION_DIALOG,
	}
}


export const resetFence = ()=>{
	return{
		type: RESET_FENCE,
	}
}

export const newFenceDrawn = (fence)=>{
	return {
		type: NEW_FENCE_DRAWN,
		payload: {
			fence,
		}
	}
}


export const setNewFenceMapCenter = (location)=>{
	return {
		type: 'SET_NEW_FENCE_MAP_CENTER',
		payload: {location}
	}
}


// WEBPACK FOOTER //
// ./src/pois/actions.js